import { Ribbon } from '@tempots/beatui'
import { attr, html } from '@tempots/dom'

/**
 * Detects the current environment
 * Returns 'local' if running against localhost, 'stage' if running in SST dev mode
 */
function detectEnvironment(stage: string) {
  const apiUrl = import.meta.env?.VITE_API_URL || ''
  return apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')
    ? 'local'
    : stage
}

/**
 * Formats the build time for display
 */
function formatBuildDate(date: Date): string {
  return date.toLocaleString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    // hour: '2-digit',
    // minute: '2-digit',
  })
}

function formatBuildTime(date: Date): string {
  return date.toLocaleString('en-US', {
    // year: 'numeric',
    // month: 'short',
    // day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

/**
 * Development environment ribbon component
 * Shows environment (local/stage) and build time in bottom-right corner
 * Only visible in non-production deployments
 */
export function DevEnvRibbon() {
  // Only show in non-production stages
  const stage = import.meta.env.VITE_STAGE || 'dev'
  if (stage === 'production') {
    return null
  }

  const environment = detectEnvironment(stage)
  const date = new Date(__BUILD_TIME__)
  const buildDate = formatBuildDate(date)
  const buildTime = formatBuildTime(date)
  const color = environment === 'local' ? 'purple' : 'blue'

  return Ribbon(
    {
      corner: 'bottom-end',
      color,
      width: 240,
      offset: 50,
    },
    attr.class('fixed'),
    html.div(
      attr.class('flex flex-col items-center text-xs font-mono'),
      html.div(attr.class('opacity-90'), buildDate),
      html.div(attr.class('opacity-90'), buildTime),
      html.div(attr.class('font-bold uppercase tracking-wider'), environment)
    )
  )
}
